import { render, staticRenderFns } from "./MonthRegistrations.vue?vue&type=template&id=79106dd7&"
import script from "./MonthRegistrations.vue?vue&type=script&lang=js&"
export * from "./MonthRegistrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MonthRegistrations.vue"
export default component.exports